module.exports = __webpack_public_path__ + "img/location.d08af0a8.svg";